import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const CheckoutLazy = lazyLoader(
  () => import('./Checkout' /* webpackChunkName: "checkout" */),
);

const Checkout = () => {
  return (
    <Suspense fallback={null}>
      <CheckoutLazy />
    </Suspense>
  );
};

export default Checkout;
